import React, { Component } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { getSEO } from "../services/seoService";

export class Portfolio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      seo: null,
      portfolio: [],
      loading: false,
      hasMore: true,
    };
  }

  async componentDidMount() {
    const seoData = await getSEO("portfolio");

    this.setState({
      seo: seoData,
    });

    this.loadPortfolio();
  }

  loadPortfolio = async () => {
    try {
      this.setState({
        loading: true,
      });

      const response = await fetch(
        "https://idealtechnoride.in/api/portfolio",
        {
          method: "POST",
        }
      );

      const data = await response.json();

      this.setState({
        portfolio: data || [],
        hasMore: data.length >= 6,
        loading: false,
      });
    } catch (error) {
      console.log(error);

      this.setState({
        loading: false,
      });
    }
  };

  loadMorePortfolio = async () => {
    try {
      const { portfolio } = this.state;

      if (portfolio.length === 0) return;

      const lastId =
        portfolio[portfolio.length - 1].portfolio_id;

      const formData = new FormData();
      formData.append("portfolio_id", lastId);

      this.setState({
        loading: true,
      });

      const response = await fetch(
        "https://idealtechnoride.in/api/portfolio",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      this.setState((prevState) => ({
        portfolio: [...prevState.portfolio, ...(data || [])],
        hasMore: data.length > 0,
        loading: false,
      }));
    } catch (error) {
      console.log(error);

      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const { portfolio, loading, hasMore } = this.state;

    return (
      <div>
        <SEO seo={this.state.seo} />

        {/* Hero Start */}
        <div className="container-fluid pb-5 hero-header mb-5">
          <div className="container py-5">
            <div className="row g-3 align-items-center">
              <div className="col-lg-6 text-center text-lg-start">
                <h1 className="display-3 mb-0 animated slideInLeft">
                  Portfolio
                </h1>
              </div>

              <div className="col-lg-6 animated slideInRight">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center justify-content-lg-end mb-0">
                    <li className="breadcrumb-item">
                      <Link className="text-secondary" to="/">
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Portfolio
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        {/* Hero End */}

        {/* Portfolio Start */}
        <div className="container py-5">
          <div className="row g-4">
            {portfolio.map((item) => (
              <div
                key={item.portfolio_id}
                className="col-lg-4 col-md-6"
              >
                <div className="blog-item bg-light rounded overflow-hidden h-100">
                  <img
                    className="img-fluid w-100 blog_image"
                    src={item.portfolio_banner_image}
                    alt={item.portfolio_title}
                    style={{
                      height: "250px",
                      objectFit: "cover",
                    }}
                  />

                  <div className="p-4">
                    <small className="text-primary">
                      {item.portfolio_category}
                    </small>

                    <h5 className="mt-2">
                      {item.portfolio_title}
                    </h5>

                    <p>
                      {item.portfolio_overview?.substring(0, 120)}
                      ...
                    </p>

                    <Link
                      to={`/portfolio/${item.portfolio_slug}`}
                      className="btn btn-primary btn-sm"
                    >
                      View Project
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* View More */}
          {hasMore && (
            <div className="text-center mt-5">
              <button
                className="btn btn-primary px-5"
                onClick={this.loadMorePortfolio}
                disabled={loading}
              >
                {loading ? "Loading..." : "View More"}
              </button>
            </div>
          )}
        </div>
        {/* Portfolio End */}
      </div>
    );
  }
}

export default Portfolio;